module.exports = __webpack_public_path__ + "static/media/komputer_indonesia_logo.2a671fa3.png";